// src/components/tableros/tabs/TipografiaTab.js - Actualizado
import React from 'react';
import {
  Grid,
  TextField,
  Typography,
  Paper,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box
} from '@mui/material';

const TipografiaTab = ({
  // Props comunes
  headerFontSize,
  setHeaderFontSize,
  nameFontSize,
  setNameFontSize,
  positionFontSize,
  setPositionFontSize,
  timeFontSize,
  setTimeFontSize,
  
  // Propiedades para tableros de campo
  resultFontSize = 54,
  setResultFontSize,
  attemptFontSize = 18,
  setAttemptFontSize,
  teamFontSize = 24,
  setTeamFontSize,
  
  // Propiedades para tableros de pista
  lapTimeFontSize = 18,
  setLapTimeFontSize,
  reactionTimeFontSize = 16,
  setReactionTimeFontSize,
  differenceTimeFontSize = 16,
  setDifferenceTimeFontSize,
  
  // Propiedades de familia de fuentes
  headerFontFamily = 'Roboto',
  setHeaderFontFamily,
  nameFontFamily = 'Roboto',
  setNameFontFamily,
  numbersFontFamily = 'Roboto Mono',
  setNumbersFontFamily,
  
  // Tipo de tablero
  boardType = 'track' // 'track', 'horizontalField', o 'verticalField'
}) => {
  const isFieldBoard = boardType === 'horizontalField' || boardType === 'verticalField';
  const isVerticalField = boardType === 'verticalField';
  
  // Opciones de fuentes organizadas por categoría
  const fontOptions = {
    display: [
      { value: 'Roboto', label: 'Roboto' },
      { value: 'Open Sans', label: 'Open Sans' },
      { value: 'Montserrat', label: 'Montserrat' },
      { value: 'Inter', label: 'Inter' },
      { value: 'Oswald', label: 'Oswald' },
      { value: 'Raleway', label: 'Raleway' }
    ],
    numbers: [
      { value: 'Roboto Mono', label: 'Roboto Mono' },
      { value: 'IBM Plex Mono', label: 'IBM Plex Mono' },
      { value: 'Courier New', label: 'Courier New' },
      { value: 'monospace', label: 'Monospace' }
    ],
    scoreboard: [
      { value: 'transist', label: 'Transist' },
      { value: 'SCOREBOARD', label: 'SCOREBOARD' },
      { value: 'CodaHeavy', label: 'CodaHeavy-JrXK' }
    ]
  };
  
  return (
    <Grid container spacing={3}>
      {/* Sección: Selección de Tipografías */}
      <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom fontWeight="medium">
          Familias de Fuentes
        </Typography>
        <Divider sx={{ mb: 2 }} />
      </Grid>
      
      {/* Selector de familia de fuente para textos */}
      <Grid item xs={12} sm={6} md={4}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Fuente para Títulos
          </Typography>
          <FormControl fullWidth size="small">
            <InputLabel id="header-font-label">Fuente de Encabezados</InputLabel>
            <Select
              labelId="header-font-label"
              value={headerFontFamily}
              label="Fuente de Encabezados"
              onChange={(e) => setHeaderFontFamily(e.target.value)}
            >
              <MenuItem disabled value="">
                <em>Fuentes de Títulos</em>
              </MenuItem>
              {fontOptions.display.map((font) => (
                <MenuItem key={font.value} value={font.value} style={{ fontFamily: font.value }}>
                  {font.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box mt={2}>
            <Typography variant="caption">Vista previa:</Typography>
            <Typography style={{ fontFamily: headerFontFamily }} mt={1}>
              Final 100m Vallas
            </Typography>
          </Box>
        </Paper>
      </Grid>
      
      {/* Selector de familia de fuente para nombres */}
      <Grid item xs={12} sm={6} md={4}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Fuente para Nombres
          </Typography>
          <FormControl fullWidth size="small">
            <InputLabel id="name-font-label">Fuente de Nombres</InputLabel>
            <Select
              labelId="name-font-label"
              value={nameFontFamily}
              label="Fuente de Nombres"
              onChange={(e) => setNameFontFamily(e.target.value)}
            >
              <MenuItem disabled value="">
                <em>Fuentes de Texto</em>
              </MenuItem>
              {fontOptions.display.map((font) => (
                <MenuItem key={font.value} value={font.value} style={{ fontFamily: font.value }}>
                  {font.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box mt={2}>
            <Typography variant="caption">Vista previa:</Typography>
            <Typography style={{ fontFamily: nameFontFamily }} mt={1}>
              Juan Pérez
            </Typography>
          </Box>
        </Paper>
      </Grid>
      
      {/* Selector de familia de fuente para números y tiempos */}
      <Grid item xs={12} sm={6} md={4}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Fuente para Números y Tiempos
          </Typography>
          <FormControl fullWidth size="small">
            <InputLabel id="numbers-font-label">Fuente Numérica</InputLabel>
            <Select
              labelId="numbers-font-label"
              value={numbersFontFamily}
              label="Fuente Numérica"
              onChange={(e) => setNumbersFontFamily(e.target.value)}
            >
              <MenuItem disabled value="">
                <em>Fuentes Numéricas</em>
              </MenuItem>
              {[...fontOptions.numbers, ...fontOptions.scoreboard].map((font) => (
                <MenuItem key={font.value} value={font.value} style={{ fontFamily: font.value }}>
                  {font.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box mt={2}>
            <Typography variant="caption">Vista previa:</Typography>
            <Typography style={{ fontFamily: numbersFontFamily }} mt={1}>
              10.85 | 1:23.45
            </Typography>
          </Box>
        </Paper>
      </Grid>

      {/* Sección: Tamaños de Fuente */}
      <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom fontWeight="medium" mt={3}>
          Tamaños de Fuente
        </Typography>
        <Divider sx={{ mb: 2 }} />
      </Grid>
      
      {/* Encabezado */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Encabezado
          </Typography>
          <TextField
            label="Tamaño (px)"
            type="number"
            value={headerFontSize}
            onChange={(e) => setHeaderFontSize(parseInt(e.target.value) || 0)}
            variant="outlined"
            size="small"
            inputProps={{ min: 10 }}
            fullWidth
          />
        </Paper>
      </Grid>
      
      {/* Nombre y Equipo */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Nombre
          </Typography>
          <TextField
            label="Tamaño (px)"
            type="number"
            value={nameFontSize}
            onChange={(e) => setNameFontSize(parseInt(e.target.value) || 0)}
            variant="outlined"
            size="small"
            inputProps={{ min: 10 }}
            fullWidth
          />
        </Paper>
      </Grid>
      
      {/* Equipo - solo visible si es tablero de campo */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Equipo
          </Typography>
          <TextField
            label="Tamaño (px)"
            type="number"
            value={teamFontSize}
            onChange={(e) => setTeamFontSize(parseInt(e.target.value) || 0)}
            variant="outlined"
            size="small"
            inputProps={{ min: 10 }}
            fullWidth
          />
        </Paper>
      </Grid>
      
      {/* Posición */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            Posición
          </Typography>
          <TextField
            label="Tamaño (px)"
            type="number"
            value={positionFontSize}
            onChange={(e) => setPositionFontSize(parseInt(e.target.value) || 0)}
            variant="outlined"
            size="small"
            inputProps={{ min: 10 }}
            fullWidth
          />
        </Paper>
      </Grid>
      
      {/* Tiempo o Marca (depende del tipo de tablero) */}
      <Grid item xs={12} sm={6} md={3}>
        <Paper variant="outlined" sx={{ p: 2 }}>
          <Typography variant="subtitle1" gutterBottom fontWeight="medium">
            {isFieldBoard ? (isVerticalField ? "Altura" : "Marca") : "Tiempo"}
          </Typography>
          <TextField
            label="Tamaño (px)"
            type="number"
            value={isFieldBoard ? resultFontSize : timeFontSize}
            onChange={(e) => {
              const value = parseInt(e.target.value) || 0;
              if (isFieldBoard) {
                setResultFontSize(value);
              } else {
                setTimeFontSize(value);
              }
            }}
            variant="outlined"
            size="small"
            inputProps={{ min: 10 }}
            fullWidth
          />
        </Paper>
      </Grid>
      
      {/* Elemento específico: Intento - para campos horizontales y verticales */}
      {isFieldBoard && (
        <Grid item xs={12} sm={6} md={3}>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle1" gutterBottom fontWeight="medium">
              {isVerticalField ? "Intentos (X/O/P)" : "Número de intento"}
            </Typography>
            <TextField
              label="Tamaño (px)"
              type="number"
              value={attemptFontSize}
              onChange={(e) => setAttemptFontSize(parseInt(e.target.value) || 0)}
              variant="outlined"
              size="small"
              inputProps={{ min: 10 }}
              fullWidth
            />
            {isVerticalField && (
              <Typography variant="caption" sx={{ display: 'block', mt: 1, fontStyle: 'italic' }}>
                Este tamaño afecta a los símbolos X (fallido), O (exitoso) y P (pase) en la tabla de intentos.
              </Typography>
            )}
          </Paper>
        </Grid>
      )}
      
      {/* Elementos específicos de pista */}
      {!isFieldBoard && (
        <>
          <Grid item xs={12} sm={6} md={3}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom fontWeight="medium">
                Tiempo de vuelta
              </Typography>
              <TextField
                label="Tamaño (px)"
                type="number"
                value={lapTimeFontSize}
                onChange={(e) => setLapTimeFontSize(parseInt(e.target.value) || 0)}
                variant="outlined"
                size="small"
                inputProps={{ min: 10 }}
                fullWidth
              />
            </Paper>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom fontWeight="medium">
                Tiempo de reacción
              </Typography>
              <TextField
                label="Tamaño (px)"
                type="number"
                value={reactionTimeFontSize}
                onChange={(e) => setReactionTimeFontSize(parseInt(e.target.value) || 0)}
                variant="outlined"
                size="small"
                inputProps={{ min: 10 }}
                fullWidth
              />
            </Paper>
          </Grid>
          
          <Grid item xs={12} sm={6} md={3}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" gutterBottom fontWeight="medium">
                Diferencia de tiempo
              </Typography>
              <TextField
                label="Tamaño (px)"
                type="number"
                value={differenceTimeFontSize}
                onChange={(e) => setDifferenceTimeFontSize(parseInt(e.target.value) || 0)}
                variant="outlined"
                size="small"
                inputProps={{ min: 10 }}
                fullWidth
              />
            </Paper>
          </Grid>
        </>
      )}

      {/* Nota sobre fuentes adicionales */}
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 2, bgcolor: 'info.main', color: 'info.contrastText' }}>
          <Typography variant="body2">
            <strong>Nota:</strong> Para que las fuentes de tablero como Transist, SCOREBOARD o CodaHeavy 
            funcionen correctamente, asegúrate de que estén incluidas en tu proyecto. 
            Estas fuentes especializadas pueden requerir importación adicional desde un CDN o 
            mediante @font-face en tu archivo CSS.
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default TipografiaTab;